import React from 'react';

import ImmersivePopup from '../ImmersivePopup/ImmersivePopup';
import AtomLoading from '../AtomLoading/AtomLoading';
import LoadingText from '../LoadingText/LoadingText';

import './AtomLoadingPopup.global.styl';

function AtomLoadingPopup({
  visible,
  text,
}: {
  visible: boolean;
  text: string;
}) {
  return (
    <ImmersivePopup visible={visible} hideCloseIconBtn>
      {visible ? (
        <div className="mio-atom-loading-popup">
          <div>
            <AtomLoading />
          </div>
          {text && (
            <div className="mio-atom-loading-popup__text">
              <LoadingText text={text} />
            </div>
          )}
        </div>
      ) : (
        undefined
      )}
    </ImmersivePopup>
  );
}

AtomLoadingPopup.defaultProps = {
  visible: false,
  text: undefined,
};

export default AtomLoadingPopup;
